export * from "/__w/wiggot-web/wiggot-web/packages/web-components/layouts/MinimalistStepLayout/MinimalistStepLayout.tsx"